import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import { Paragraph, Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import InfoIcon from 'assets/images/icons/encircled-info.svg';
import './FeeWarningToolTipV2.scss';

export const enhance = compose(
	withProps(({ facility }) => ({
		fees: [
			{
				name: 'One-Time Admin Fee',
				price: facility.adminFee,
			},
			{
				name: 'One-Time Lock Fee',
				price: facility.lockFee,
			},
		],
		totalFees: facility.totalFees,
	})),
);

export function FeeWarningToolTipV2({ fees, totalFees, className }) {
	return (
		<Tooltip
			className={classnames('tooltip-banner', className)}
			content={
				<Paragraph
					size="tiny"
					color="gray"
				>
					The following fees shall apply:
					<ul>
						{fees.map(
							(fee) =>
								fee.price > 0 && (
									<li
										key={fee.name}
										className="fee-item"
									>
										{`${fee.name}: $${fee.price}`}
									</li>
								),
						)}
					</ul>
				</Paragraph>
			}
		>
			<Text
				last
				size="tiny"
				color="gray"
				className="fee-warning-tooltip-v2-text"
			>
				<img
					src={InfoIcon}
					alt="Info"
					className="info-icon"
				/>{' '}
				{totalFees} in fees
			</Text>
		</Tooltip>
	);
}

FeeWarningToolTipV2.propTypes = {
	fees: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			price: PropTypes.number,
		}),
	).isRequired,
	totalFees: PropTypes.number.isRequired,
	className: PropTypes.string,
};

export default enhance(FeeWarningToolTipV2);
